import { useQuery } from "@tanstack/react-query";
import CounterService from "services/CounterService";

const useGetCounterInfos = (queryOptions = {}) => {
  return useQuery({
    queryKey: ["counter"],
    queryFn: () => CounterService.getCounterInfos(),
    ...queryOptions,
  });
};

export default useGetCounterInfos;
